import { Icon, IIconProps } from 'native-base';
import { Path } from 'react-native-svg';

export const RainIcon = ({ size = 'sm', fill = '#464648', ...props }: IIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 100 100" fill="none" {...props}>
      <Path
        d="M0 0 C4.40802625 2.16394016 7.23139226 4.38196867 9 9 C9.6506657 15.07287984 9.88863195 19.14173515 6 24 C5.855625 25.155 5.71125 26.31 5.5625 27.5 C4.90685814 31.57954932 4.2033135 32.5051116 1 35 C-1.77734375 35.54589844 -1.77734375 35.54589844 -4.9375 35.609375 C-6.65066406 35.65771484 -6.65066406 35.65771484 -8.3984375 35.70703125 C-9.58695313 35.72121094 -10.77546875 35.73539063 -12 35.75 C-13.78277344 35.79447266 -13.78277344 35.79447266 -15.6015625 35.83984375 C-36.206143 36.32821417 -36.206143 36.32821417 -41.625 31.8125 C-43.39191844 28.19834865 -43.56857278 25.98000943 -43 22 C-41.375 19.125 -41.375 19.125 -39 17 C-35.75 16.1875 -35.75 16.1875 -33 16 C-33.103125 15.113125 -33.20625 14.22625 -33.3125 13.3125 C-32.90194499 8.96061694 -31.28831975 7.74026646 -28 5 C-24.98131566 3.49065783 -22.32702771 3.82489328 -19 4 C-18.01 4.66 -17.02 5.32 -16 6 C-15.67 5.01 -15.34 4.02 -15 3 C-10.597772 -0.83419858 -5.5388312 -0.79886988 0 0 Z "
        fill="currentColor"
        transform="translate(67,25)"
      />
      <Path
        d="M0 0 C4.40802625 2.16394016 7.23139226 4.38196867 9 9 C10.01203114 18.44562397 10.01203114 18.44562397 7.4765625 22.33984375 C6.98929688 22.88769531 6.50203125 23.43554688 6 24 C3.03 23.01 0.06 22.02 -3 21 C-3.33 18.69 -3.66 16.38 -4 14 C-4.61488281 13.98582031 -5.22976562 13.97164062 -5.86328125 13.95703125 C-12.46401426 13.56751431 -12.46401426 13.56751431 -15.125 10.75 C-16.14539298 7.54305064 -16.30812411 6.10679475 -15 3 C-10.7892651 -0.93907458 -5.43513776 -0.7839141 0 0 Z "
        fill={fill}
        transform="translate(67,25)"
      />
      <Path
        d="M0 0 C1.98 0.495 1.98 0.495 4 1 C3.34 2.98 2.68 4.96 2 7 C1.01 6.67 0.02 6.34 -1 6 C-0.67 4.02 -0.34 2.04 0 0 Z "
        fill="#49484A"
        transform="translate(36,64)"
      />
      <Path
        d="M0 0 C1.32 0 2.64 0 4 0 C3.67 1.98 3.34 3.96 3 6 C1.68 6 0.36 6 -1 6 C-0.67 4.02 -0.34 2.04 0 0 Z "
        fill="#484749"
        transform="translate(44,63)"
      />
      <Path
        d="M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 2.65 2.34 4.3 2 6 C0.68 6 -0.64 6 -2 6 C-1.125 1.125 -1.125 1.125 0 0 Z "
        fill="#49484A"
        transform="translate(51,69)"
      />
      <Path
        d="M0 0 C0.99 0 1.98 0 3 0 C2.67 1.65 2.34 3.3 2 5 C1.01 4.67 0.02 4.34 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z "
        fill="#49484A"
        transform="translate(42,70)"
      />
      <Path
        d="M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 2.32 2.34 3.64 2 5 C1.01 4.67 0.02 4.34 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z "
        fill="#444446"
        transform="translate(54,61)"
      />
    </Icon>
  );
};
